import { trackExperimentSetEvent } from 'chimera/all/plugins/tracking/clarity/events'

/**
 * @param {object} Vue
 * @param {object} options
 * @param {Function} options.enqueueEvent
 */
export function bindEvents(Vue, { enqueueEvent }) {
  Vue.$eventBus.onExperimentSetEvent((event) => {
    enqueueEvent('onExperimentSetEvent', () => trackExperimentSetEvent(event))
  })
}
